module.exports = __webpack_public_path__ + "media/images/icon__arrow-right-4f86ca15d40fe3bc02f0212ec1855c13.png";